import type {
    AlphaEyeWidgetModel,
    AlphaLensWidgetModel,
    Widget,
    WidgetTab,
} from '@thinkalpha/ui-types/contracts/workspace';
import { AlphaEyeWidgetModelImpl } from 'src/models/AlphaEyeWidgetModel/impl';

function legacyAlphaEyeSymbol(widget: AlphaLensWidgetModel): string {
    const symbol = typeof widget.symbol === 'string' ? widget.symbol.trim() : '';
    return symbol || AlphaEyeWidgetModelImpl.defaultState().symbol;
}

export function normalizeLegacyAlphaEyeWidget(widget: Widget): Widget {
    if (widget.type !== 'alpha-lens') {
        return widget;
    }

    const migratedState = AlphaEyeWidgetModelImpl.stateSchema.decode({
        ...AlphaEyeWidgetModelImpl.stateSchema.encode(AlphaEyeWidgetModelImpl.defaultState()),
        symbol: legacyAlphaEyeSymbol(widget),
        isChartCollapsed: widget.defaultChartCollapse ?? true,
    });

    return {
        type: 'alpha-eye',
        channelId: widget.channelId ?? null,
        ...migratedState,
    } satisfies AlphaEyeWidgetModel;
}

export function normalizeLegacyAlphaEyeTab(tab: WidgetTab): WidgetTab {
    const widget = normalizeLegacyAlphaEyeWidget(tab.widget);
    if (widget === tab.widget) {
        return tab;
    }

    return {
        ...tab,
        widget,
    };
}
